import React from 'react';
import { useFocusRing } from '@react-aria/focus';
import { mergeProps } from '@react-aria/utils';
import { cn } from '../../utils/cn';
function FocusRing({ children, ...props }) {
    const { isFocusVisible, focusProps } = useFocusRing(props);
    const child = React.Children.only(children);
    return React.cloneElement(child, mergeProps(child.props, {
        ...focusProps,
        className: cn({
            'focus:outline-none focus:shadow-outline': isFocusVisible,
        }),
    }));
}
export default FocusRing;
